import styled from 'styled-components';

export const RegionLanguageSwitcherStyled = styled.div`
  display: flex;
  gap: 8px;
  .country-dropdown {
    .dropdown-toggle {
      width: auto !important;
      border:none;
      padding:0;
      background:transparent !important;
      padding-right: 20px;
      &::after {
        left: auto;
        right: 0px;
      }
     
      .ic {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        overflow: hidden;
        margin: 0px;
      }
    }
    .dropdown-menu {
      border-color: ${(props) => props.theme.colors.neutral.darkBlue['50']} !important;
      box-shadow: 0px 8px 32px 0px #0000001F;
      width: auto !important;
      height: auto !important;
      max-height: 160px !important;
      .dropdown-menu-item {
        .dropdown-item {
          padding: 16px !important;
          .ic {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;
            margin: 0;
          }
        }
      }
    }
    &.rtl {
      .dropdown-toggle {
        padding: 0 0 0 20px;
        &::after {
          left: 0px;
          right: auto;
        }
      }
    }
  }
  .lang-separator {
    color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['400']};
    line-height: 20px;
    font-weight: 600;
    font-size: 16px;
  }
  .lang-selector {
    color: ${(props) => props?.theme?.colors?.primary?.green?.['700']};
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    cursor: pointer;
  }

  &.rtl {
    flex-direction: row-reverse;
  }
`;